import React from 'react';
export function Navbar() {
  return <nav className="sticky top-0 z-50 w-full bg-charcoal/80 backdrop-blur-md border-b border-white/10 ml-[0px] mr-[0px]" data-id="element-254">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 h-16 flex pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[0px] mb-[0px] ml-[0px] mr-[0px] gap-[35px] flex-row items-center justify-center" data-id="element-255">
        <div className="flex items-center" data-id="element-256">
          <img src="https://cdn.magicpatterns.com/uploads/tzoX4mQjUNN8ck8vrG7H2j/Zentral_Pro_Logo_blanco.png" alt="Zentral Pro" className="h-10 object-contain" loading="eager" decoding="async" width="120" height="40" data-id="element-257" />
        </div>
        <div className="hidden md:flex items-center gap-6 text-sm font-medium text-gray-300" data-id="element-258">
          <a href="#sistema" className="hover:text-gold transition-colors" data-id="element-259">
            Los Tomos
          </a>
          <a href="#bonos" className="hover:text-gold transition-colors" data-id="element-260">
            Bonos
          </a>
          <a href="#precios" className="hover:text-gold transition-colors" data-id="element-261">
            Precios
          </a>
        </div>
        <a href="#precios" className="bg-gradient-to-br from-gold via-gold-light to-gold hover:brightness-110 text-[#1a1000] px-6 py-2.5 rounded font-bold text-sm transition-all shadow-sm" data-id="element-262">
          Quiero mi MegaPack
        </a>
      </div>
    </nav>;
}